<div
  class="page-container page-containers"
  [ngClass]="{
    'disabled-project': sectorBasedLossData?.isLockProject || productDetailsData?.isLockProject
  }"
  *ngrxLet="{
    productMixList: (projectsFacade.productMixList$ | async),
    error: (projectsFacade.productMixErrorStr$ | async)
  } as prodMixData"
  [formGroup]="productLossBasedOnSectForm"
>
  <div class="page-head">
    <div>
      <div class="page-title">
        <span class="headerName">{{ headerData!.title }}</span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <label class="subTitleName">
        <span
          [title]="'Welcome to the new Product section.'"
          text="This is where you:
                - Select or change your product sector data.
                - Configure your packaging contents.
                - Select the functional unit.
                Tip: Keep the function unit as '1' unless it's a concentrate!"
          (prev)="backToMaterial()"
          [joyrideStep]="'step19'"
          [stepPosition]="'right'"
          >Packaging contents configuration</span
        >
      </label>
    </div>
  </div>

  <div class="row">
    <div class="col-8 d-flex align-items-center">
      <div>
        <p class="mt-3 mb-3 h6">{{ subTitleText }}</p>
      </div>
    </div>

    <ng-container *ngrxLet="sharedService.startTourObs$ as isTourOn">
      <div class="col-3" *ngIf="isSectorBased || isTourOn">
        <div class="return-settings my-4">
          <a
            text="You can change your product sector selection by going back to 'Project settings'."
            [joyrideStep]="'step20'"
            [stepPosition]="'left'"
            target="_blank"
            (click)="routeToProjectSettings()"
            >Return to Project settings</a
          >
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row" *ngIf="activatedRoute !== 'product'" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-11 form-group">
      <div
        *ngIf="productLossBasedOnSectForm.get('sectorIdentier')?.value"
        class="d-flex align-items-center"
      >
        <div>
          <p class="my-2 h6">Product sector data *</p>
        </div>
        <div></div>
      </div>
      <div
        class="sector-drp"
        *ngIf="!isSectorBased && activatedRoute == 'product-loss-sector'"
        [piqetAngularSectionAccess]="FeatureCodes.PRODUCT_PRODUCT_SECTOR_DATA"
      >
        <ng-select
          [clearable]="true"
          [clearOnBackspace]="false"
          [virtualScroll]="true"
          #sectorDrp
          [items]="sectorBasedLossData?.sectorIdentifierList"
          [searchable]="false"
          [searchFn]=""
          bindLabel="name"
          placeholder="Product sector data"
          formControlName="sectorIdentier"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                placeholder="Search..."
                type="text"
                id="inputValidation"
                class="form-control accordion-search search-input"
                (input)="sectorDrp.filter($any($event.target).value)"
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="submitted && productLossBasedOnSectForm.controls['sectorIdentier']?.invalid"
          class="input-error"
        >
          Product sector identifier is required.
        </div>
      </div>

      <div class="required" *ngIf="isSectorBased && activatedRoute == 'product-loss'">
        <div
          *ngIf="productLossBasedOnSectForm.get('prodSectorData')?.value"
          class="d-flex align-items-center"
        >
          <div>
            <p class="my-2 h6">Product sector data *</p>
          </div>
          <div></div>
        </div>
        <div class="services-form">
          <input
            type="text"
            formControlName="prodSectorData"
            placeholder="Product sector data"
            #prodSectData
          />
          <label *ngIf="!productLossBasedOnSectForm.get('prodSectorData')?.value"
            >Product sector data</label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-6">
      <div class="form-group required">
        <piqet-angular-common-input
          formControlName="mass"
          [control]="productLossBasedOnSectForm.get('mass')"
          label="Mass/volume in a retail pack"
          placeholder="Mass/volume in a retail pack"
          inputType="number"
          [maxLength]="50"
          [enableRangeValidation]="true"
          [preventNegative]="true"
          [required]="true"
          [submitted]="submitted"
          [showTooltip]="true"
          [tooltipText]="
            'Enter the mass or volume of product that is contained in the smallest unit of your packaging system.'
          "
          [tooltipPlacement]="'auto'"
          [tooltipClass]="'sku-tooltip'"
          [errorMessages]="{
            required: 'Mass/volume in a retail pack is required',
            min: 'Mass/volume in a retail pack must be greater than 0',
            greaterThanZero: 'Mass/volume must be greater than 0'
          }"
        >
        </piqet-angular-common-input>
      </div>
    </div>

    <div class="col-5">
      <div class="form-group">
        <label for="unit" id="unit" class="sub-header-drpdown">Unit</label>
        <ng-select
          [clearable]="true"
          [clearOnBackspace]="false"
          [virtualScroll]="true"
          #sectorDrp
          [items]="unitList"
          [searchable]="false"
          [searchFn]=""
          bindLabel="description"
          formControlName="unit"
          placeholder="Unit"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                placeholder="Search..."
                type="text"
                id="inputValidation"
                class="form-control accordion-search search-input"
                (input)="sectorDrp.filter($any($event.target).value)"
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.description }}">
              {{ item?.description }}
            </div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="submitted && productLossBasedOnSectForm.controls['unit']?.invalid"
          class="input-error"
        >
          Unit is required.
        </div>
      </div>
    </div>
  </div>

  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-11 form-group">
      <div class="required">
        <div class="d-flex align-items-center">
          <div>
            <p
              text="This is only used to scale a product based on its performance."
              (next)="onNext('step22')"
              [joyrideStep]="'step22'"
              [stepPosition]="'bottom'"
              class="m-0 p-0"
            >
              Functional unit multiplier *
            </p>
          </div>
          <div>
            <span
              placement="auto"
              tooltipClass="sku-tooltip"
              ngbTooltip="This is used to scale a product based on performance, e.g. concentrates. In projects where this is not relevant, leave as “1”."
            >
              <a class="info-icon">
                <span>
                  <img src="./assets/icons/grey-question-icon.svg" width="14" height="14" /></span
              ></a>
            </span>
          </div>
        </div>
        <div class="services-form">
          <input
            type="number"
            formControlName="funcUnitMultiplier"
            placeholder="Functional unit multiplier"
            #funcUnitMultiplier
            piqetAngularInputNumber
            [preventNegative]="true"
          />
          <div
            *ngIf="(submitted && productLossBasedOnSectForm.controls['funcUnitMultiplier']?.errors?.['required'])"
            class="input-error"
          >
            Functional unit multiplier is required.
          </div>
          <div
            *ngIf="
              submitted &&
              productLossBasedOnSectForm.controls['funcUnitMultiplier']?.hasError('greaterThanZero')
            "
            class="input-error"
          >
            Functional unit multiplier must be greater than 0.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-6">
      <div class="form-group required">
        <div class="d-flex align-items-center">
          <div>
            <p class="m-0 p-0">Bulk density (kg/litre) *</p>
          </div>
        </div>
        <div class="services-form">
          <input
            piqetAngularDecimalLimit
            type="number"
            maxlength="50"
            formControlName="bulkDensity"
            placeholder="Bulk density (kg/litre)"
            piqetAngularInputNumber
            [preventNegative]="true"
          />
          <div
            *ngIf="(submitted && productLossBasedOnSectForm.controls['bulkDensity']?.errors?.['required'])"
            class="input-error"
          >
            Bulk density is required.
          </div>
          <div
            *ngIf="
              submitted &&
              productLossBasedOnSectForm.controls['bulkDensity']?.hasError('greaterThanZero')
            "
            class="input-error"
          >
            Bulk density must be greater than 0.
          </div>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div class="form-group required">
        <div class="d-flex align-items-center">
          <div>
            <p class="m-0 p-0">Annual retail volume (units)</p>
          </div>
        </div>
        <div class="services-form">
          <input
            type="number"
            maxlength="50"
            formControlName="retailVolume"
            piqetAngularInputNumber
            [preventNegative]="true"
            placeholder="Annual retail volume (units) "
          />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer box-footer" *ngIf="isSectorBased">
    <button
      type="button"
      (click)="saveSectorData()"
      class="modelBtn purpleBtnHoverEffect"
      *ngIf="showEdit"
    >
      Save
    </button>
    <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
  </div>

  <div class="row">
    <div class="col-11">
      <div class="modal-footer submit-class box-footer" *ngIf="!isSectorBased">
        <button
          (click)="saveData()"
          type="button"
          [disabled]="disableSubmit || isRowEditable"
          *ngIf="showEdit"
          class="modelBtn purpleBtnHoverEffect"
        >
          Submit
        </button>
        <ng-container *ngIf="activatedRoute !== 'product'">
          <piqet-angular-navigation-button [config]="navigationConfig">
          </piqet-angular-navigation-button>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    class="row"
    *ngIf="!isSectorBased && activatedRoute == 'product'"
    [ngClass]="{ 'disabled-popup': !showEdit }"
  >
    <div class="col-11 d-flex justify-content-between">
      <div>
        <label class="subTitleName">Product mix</label>
        <span
          placement="auto"
          tooltipClass="sku-tooltip"
          ngbTooltip="Enter the products previously modeled in Product project"
        >
          <a class="info-icon">
            <span> <img src="./assets/icons/question-mark-icon.svg" width="14" height="14" /></span
          ></a>
        </span>
      </div>
      <div class="return-settings subTitleName" *ngIf="showEdit">
        <a
          class="add-link"
          [routerLink]="['/projects']"
          [queryParams]="{ isFromProj: encodedUrl }"
          target="_blank"
          >Create Product project</a
        >
        <a
          class="setLinkIconPosition"
          [routerLink]="['/projects']"
          [queryParams]="{ isFromProj: encodedUrl }"
          target="_blank"
        >
          <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
        </a>
        <span class="refresh-icon-class" (click)="refreshProductList()"
          ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
        /></span>
      </div>
    </div>

    <div class="col-8">
      <div>
        <p class="mt-3 mb-3 h6">
          Establish the product mix as a percentage relative to the total of 100%
        </p>
      </div>
    </div>
  </div>

  <div class="input-error" *ngIf="!isSectorBased && activatedRoute == 'product'">
    {{ prodMixDataError }}
  </div>
  <div
    class="row"
    class="product-form-margin"
    *ngIf="!isSectorBased && activatedRoute == 'product'"
    [ngClass]="{ 'disabled-popup': !showEdit }"
    [ngClass]="isProdMixDisabled ? '' : 'disabled-project'"
  >
    <piqet-angular-portlet
      [columnDefs]="colDefs"
      [frameworkComponents]="frameworkComponents"
      [class]="'overflowCheck'"
      [gridData]="prodMixData?.productMixList"
      [hideSearch]="true"
      [hidePagination]="true"
      [gridName]="'product-loss-grid'"
    >
    </piqet-angular-portlet>
  </div>
  <div
    class="row"
    *ngIf="!isSectorBased && activatedRoute == 'product' && !hideShowAddSectionFlag"
    [ngClass]="isProdMixDisabled ? '' : 'disabled-project'"
  >
    <div class="col-11 d-flex justify-content-center">
      <div class="modal-footer submit-class box-footer">
        <button
          type="button"
          class="modelBtn addProductBtn purpleBtnHoverEffect"
          *ngIf="showEdit"
          (click)="hideShowAddSection()"
        >
          Add product
        </button>
      </div>
    </div>
  </div>
  <div
    class="row"
    [formGroup]="productGridForm"
    *ngIf="!isSectorBased && activatedRoute == 'product' && hideShowAddSectionFlag"
    [ngClass]="productLossBasedOnSectForm.invalid ? 'disabled-project' : ''"
  >
    <div class="col-3">
      <div class="form-group">
        <label
          *ngIf="productGridForm?.get('productDropDown')?.value"
          class="sub-header-drpdown pb-2"
          >Product</label
        >
        <ng-select
          [clearable]="true"
          [clearOnBackspace]="false"
          [virtualScroll]="true"
          #sectorDrp
          [items]="productDetailsProductList"
          [searchable]="false"
          [searchFn]="commonInputSearch"
          formControlName="productDropDown"
          bindLabel="name"
          bindValue="idLong"
          placeholder="Product"
          groupBy="childItems"
          (change)="changeProductDes($event)"
        >
          <ng-template ng-header-tmp>
            <div class="has-feedback">
              <input
                placeholder="Search..."
                type="text"
                id="inputValidation"
                class="form-control accordion-search search-input"
                (input)="sectorDrp.filter($any($event.target).value)"
              />
              <span class="form-control-feedback">
                <i class="fa fa-search icon"></i>
              </span>
            </div>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
              {{ item?.name }}
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <div [ngOptionHighlight]="search" title="{{ item?.name }}">
              {{ item?.name }}
            </div>
          </ng-template>
        </ng-select>
        <div
          *ngIf="submitForProduct && productGridForm.controls['productDropDown']?.invalid"
          class="input-error"
        >
          Product is required.
        </div>
      </div>
    </div>

    <div class="col-3">
      <div class="form-group">
        <label
          *ngIf="productGridForm?.get('productDropDown')?.value"
          class="placeholder-sub-header pb-1"
          >Holder_text</label
        >
        <div class="services-form">
          <input type="text " placeholder="Description" formControlName="productDescription" />
          <label>Description</label>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="form-group">
        <label
          *ngIf="productGridForm?.get('productDropDown')?.value"
          class="placeholder-sub-header pb-1"
          >Holder_text</label
        >
        <div class="services-form">
          <input
            type="number"
            placeholder="Ratio (%)"
            formControlName="productRatio"
            piqetAngularInputNumber
            [preventNegative]="true"
          />
          <label>Ratio (%)</label>
          <div
            *ngIf="(submitForProduct && productGridForm.controls['productRatio']?.errors?.['required'])"
            class="input-error"
          >
            Ratio is required.
          </div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <label
        *ngIf="productGridForm?.get('productDropDown')?.value"
        class="placeholder-sub-header pb-1"
        >Holder_text</label
      >
      <div class="modal-footer box-footer">
        <button
          (click)="addProductGridData(prodMixData?.productMixList)"
          type="button"
          class="modelBtn purpleBtnHoverEffect"
        >
          {{ isCheckProductUpdate ? 'Update' : 'Add' }}
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-11">
      <div class="modal-footer box-footer" *ngIf="activatedRoute == 'product'">
        <piqet-angular-navigation-button [config]="navigationConfig">
        </piqet-angular-navigation-button>
      </div>
    </div>
  </div>
</div>
